(function () {
  var chainPrice = 25;
  var moneyFormatter = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });

  function isProductPage() {
    var main = document.getElementById('MainContent');
    return Boolean(main && /product/.test(main.getAttribute('data-template') || ''));
  }

  function isMainProductForm(form) {
    if (!isProductPage() || !form) return false;
    if (form.closest('.product-card, [class*="product-card"], quick-add-component, quick-add-modal, .quick-add-modal, predictive-search')) return false;
    return Boolean(form.closest('.product-information, [data-product-grid-content], product-form-component'));
  }

  function parseMoney(text) {
    if (!text) return null;
    var cleaned = String(text)
      .replace(/\s/g, '')
      .replace(/[^0-9,.-]/g, '')
      .replace(',', '.');
    var value = parseFloat(cleaned);
    return Number.isFinite(value) ? value : null;
  }

  function getProductPrice(form) {
    var productArea = form.closest('.product-information') || form.closest('[data-product-grid-content]') || document;
    var metaAmount = document.querySelector('meta[property="product:price:amount"], meta[property="og:price:amount"]');
    if (metaAmount) {
      var metaPrice = parseMoney(metaAmount.getAttribute('content'));
      if (metaPrice !== null) return metaPrice;
    }

    var selectors = [
      'product-price',
      '[data-testid*="price" i]',
      '.price',
      '[class*="price" i]'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var elements = productArea.querySelectorAll(selectors[i]);
      for (var j = 0; j < elements.length; j += 1) {
        var element = elements[j];
        if (element.closest('.product-card, [class*="product-card"], .cart-items, cart-items')) continue;
        var text = element.textContent || '';
        if (!/€/.test(text)) continue;
        var price = parseMoney(text);
        if (price !== null) return price;
      }
    }

    return null;
  }

  function getQuantity(form) {
    var input = form.querySelector('[name="quantity"], quantity-selector input, input[type="number"]');
    var quantity = parseInt(input && input.value, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function isChainChecked(form) {
    var scope = form.closest('product-form-component') || form.parentElement || document;
    var checkbox = scope.querySelector('.rustico-chain-addon__input');
    return Boolean(checkbox && checkbox.checked);
  }

  function formatPrice(amount) {
    return moneyFormatter.format(amount).replace(/\s/g, '');
  }

  function getButtonLabel(button) {
    var cleanLabel = 'Ajouter au panier';
    var text = (button.textContent || '').trim();
    if (/sold out|épuisé|indisponible/i.test(text)) cleanLabel = text;
    return cleanLabel;
  }

  function updateButton(form) {
    if (!isMainProductForm(form) || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;

    var button = form.querySelector('button[type="submit"], [type="submit"], button[name="add"]');
    if (!button || button.disabled && /ajout en cours/i.test(button.textContent || '')) return;

    var price = getProductPrice(form);
    if (price === null) return;

    var quantity = getQuantity(form);
    var total = price * quantity;
    if (isChainChecked(form)) total += chainPrice * quantity;

    button.textContent = getButtonLabel(button) + ' – ' + formatPrice(total);
  }

  function updateAllButtons() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(updateButton);
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('[name="quantity"], input[type="number"], .rustico-chain-addon__input, variant-picker input, .variant-picker input')) {
      window.setTimeout(updateAllButtons, 30);
      window.setTimeout(updateAllButtons, 180);
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest('quantity-selector, .rustico-chain-addon, .variant-picker, variant-picker')) {
      window.setTimeout(updateAllButtons, 60);
      window.setTimeout(updateAllButtons, 220);
    }
  }, true);

  document.addEventListener('submit', function () {
    window.setTimeout(updateAllButtons, 900);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllButtons);
  } else {
    updateAllButtons();
  }

  window.setTimeout(updateAllButtons, 300);
  window.setTimeout(updateAllButtons, 1000);
  document.addEventListener('shopify:section:load', updateAllButtons);
  document.addEventListener('shopify:section:select', updateAllButtons);
})();
